export const DEFAULT_TEST_ID = 'global-invite';

export const MODAL_DIALOG_TEST_ID = 'modal-dialog';

export const TRIGGER_ELEMENT_TEST_ID = 'trigger-element';

export const ANALYTICS_CHANNEL = 'navigation';
